 import {LOCALE_ID, NgModule} from '@angular/core';
import { ZeiterfassungFormdialogNeuComponent } from './components/zeiterfassung-formdialog-neu/zeiterfassung-formdialog-neu.component';
import { ZeiterfassungPageComponent } from './components/zeiterfassung-page/zeiterfassung-page.component';
import { ZeiterfassungListComponent } from './components/zeiterfassung-list/zeiterfassung-list.component';
import { ZeiterfassungTableComponent } from './components/zeiterfassung-table/zeiterfassung-table.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { StoreModule } from '@ngrx/store';
import { zeiterfassungReducer } from './store/reducer/zeiterfassung.reducer';
import { ZeitService } from './zeit.service';
import { EffectsModule } from '@ngrx/effects';
import { ZeiterfassungEffects } from './store/effects/zeiterfassung.effects';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatTableModule } from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTreeModule } from '@angular/material/tree';
import { ZeiterfassungStufenComponent } from './components/zeiterfassung-stufen/zeiterfassung-stufen.component';
import { MatSortModule } from '@angular/material/sort';
import {ColorPickerModule} from 'ngx-color-picker';
import { SharedModule } from '../../shared.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {MatTabsModule} from '@angular/material/tabs/';
import {SpesenTableComponent} from './components/spesen-table/spesen-table.component';
import {SpesenService} from './spesen.service';
import {SpesenEffects} from './store/effects/spesen.effects';
import {SpesenFormdialogComponent} from './components/spesen-form-dialog/spesen-formdialog.component';
import {CacheService} from './cache.service';
import {CacheEffects} from './store/effects/cache.effects';
import {MatRadioModule} from '@angular/material/radio';
import {SpesenartPageFormComponent} from './components/spesenart-pageForm/spesenart-pageform.component';
import {SpesenartTableComponent} from './components/spesenart-table/spesenart-table.component';
import {SpesenartService} from './spesenart.service';
import {SpesenartEffects} from './store/effects/spesenart.effects';
import {SpesenartFormdialogComponent} from './components/spesenart-form-dialog/spesenart-formdialog.component';
import {ZeiterfassungFilterComponent} from './components/zeiterfassung-filter/zeiterfassung-filter.component';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {registerLocaleData} from '@angular/common';
import localeDECH from '@angular/common/locales/de-CH';


 registerLocaleData(localeDECH);

@NgModule({
    imports: [
        StoreModule.forFeature('zeiterfassung', zeiterfassungReducer),
        EffectsModule.forFeature([ZeiterfassungEffects, SpesenEffects, CacheEffects, SpesenartEffects]),
        MatToolbarModule,
        TranslateModule,
        MatIconModule,
        MatButtonModule,
        MatDialogModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        FormsModule,
        MatInputModule,
        MatCheckboxModule,
        BrowserAnimationsModule,
        BsDatepickerModule.forRoot(),
        MatDatepickerModule,
        FlexLayoutModule,
        MatTableModule,
        MatMenuModule,
        MatSelectModule,
        MatTreeModule,
        MatSortModule,
        ColorPickerModule,
        SharedModule,
        MatTooltipModule,
        TooltipModule,
        MatTabsModule,
        MatRadioModule,
        MatMomentDateModule,
        MatAutocompleteModule,
    ],
    providers: [
      {
        provide: LOCALE_ID,
        useValue: 'de-CH'
      },
      ZeitService, SpesenService, CacheService, SpesenartService],
    declarations: [
        ZeiterfassungFormdialogNeuComponent,
        ZeiterfassungPageComponent,
        ZeiterfassungListComponent,
        ZeiterfassungTableComponent,
        ZeiterfassungStufenComponent,
        SpesenTableComponent,
        SpesenFormdialogComponent,
        SpesenartTableComponent,
        SpesenartPageFormComponent,
        SpesenartFormdialogComponent,
        ZeiterfassungFilterComponent
    ],
    exports: [
        ZeiterfassungStufenComponent,
        SpesenartTableComponent
    ]
})
export class ZeiterfassungPageComponentModule { }
